<template>
  <!-- <a-form layout="vertical" :form="form" @submit="handleSubmit">
    <a-form-item :validate-status="userNameError() ? 'error' : ''" :help="userNameError() || ''">
      <a-input
        v-decorator="[
          'userName',
          { rules: [{ required: true, message: this.$t('message.nameErr') }] },
        ]"
        :placeholder="userName"
      >
        <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>

    <a-form-item :validate-status="phoneError() ? 'error' : ''" :help="phoneError() || ''">
      <a-input
        v-decorator="[
          'phone',
          { rules: [{ required: true, message: this.$t('message.phoneErr') }] },
        ]"
        :placeholder="this.$t('message.phoneErr')"
      >
        <a-icon slot="prefix" type="mobile" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>
    <a-form-item :validate-status="codeError() ? 'error' : ''" :help="codeError() || ''">
      <a-input-search :placeholder="this.$t('message.codeErr')"  @search="onSearch">
            <a-icon slot="prefix" type="safety" style="color:rgba(0,0,0,.25)" />
            <a-button  type="primary" slot="enterButton">
                {{this.$t('message.sendCode')}}
            </a-button>
      </a-input-search>
    
    </a-form-item>

    <a-form-item :validate-status="passwordError() ? 'error' : ''" :help="passwordError() || ''">
      <a-input
        v-decorator="[
          'password',
          { rules: [{ required: true, message: this.$t('message.pwdErr') }] },
        ]"
        type="password"
        :placeholder="password"
      >
        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-button
        block
        type="primary"
        size="large"
        html-type="submit"
      >{{this.$t('message.register')}}</a-button>
    </a-form-item>
  </a-form> -->
  <a-form-model
    ref="registerForm"
    :model="form"
    :rules="rules"

  >
    <a-form-model-item  prop="username">
      <a-input v-model="form.username" :placeholder="$t('message.nameErr')">
        <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-model-item>
    <a-form-model-item  prop="phone">
      <a-input v-model="form.phone" :placeholder="$t('message.phoneErr')">
        <a-icon slot="prefix" type="mobile" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-model-item>
    <a-form-model-item  prop="code">
      <a-input-search v-model="form.code" :placeholder="this.$t('message.codeErr')" @search="sendCode">
        <a-icon slot="prefix" type="safety" style="color:rgba(0,0,0,.25)" />
        <a-button :disabled="sendBtn" type="primary" slot="enterButton" >
            {{sendBtnTitle}}
        </a-button>
      </a-input-search>

    </a-form-model-item>
    <a-form-model-item  prop="password">
      <a-input-password v-model="form.password" :placeholder="$t('message.pwdErr')" >
        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
      </a-input-password>
    </a-form-model-item>
    <a-form-model-item>
      <a-button block type="primary" size="large"  @click="registerSubmit">{{this.$t('login.register')}}</a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { regiser } from "@/api/user.js";
import { sendSms } from "@/api/index.js";
import { validatephone } from "@/utils/validate";
import { isMobile } from "@/utils/tools.js";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t("form.common.field.phone.checkMessage"));
        return;
      }
      callbackFn();
    };
    return {
      hasErrors,
      form: {},
      rules:{
        username:[{required:true,message:this.$t('message.nameErr'),trigger: "blur",}],
        phone:[
          {required:true,message:this.$t("message.phoneErr"),trigger: "blur",},
          { validator: phoneCheck, trigger: "blur" },
        ],
        code:[{required:true,message:this.$t("message.codeErr"),trigger: "blur",}],
        password:[{required:true,message:this.$t("message.pwdErr"),trigger: "blur",}],
      },
      sendBtn:false,
      sendBtnTitle:this.$t('message.sendCode'),
      countDown:60,
      timeOut:undefined,
      isDoubleClick: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    onClickForCode() {},
    clickToLogin() {
      this.$emit("toLogin");
    },
    sendCode(){
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if(this.form.phone==""){
        this.$message.error(this.$t("message.phoneErre"),2);
        return;
      }else if(!validatephone(this.form.phone)){
        this.$message.error(this.$t("message.phoneErr"),2);
        return false;
      }
      // let timeOut = null;
      this.sendBtn = true;
      sendSms({phone:this.form.phone}).then(res=>{
        if(res.code==1){
          this.timeOut = setInterval(()=>{
            this.sendBtnTitle = this.countDown+this.$t("message.sendAwait");
            if(this.countDown<=0){
              window.clearInterval(this.timeOut);
              this.countDown = 60;
              this.sendBtn = false;
              this.sendBtnTitle = this.$t('message.sendCode');
            }
            this.countDown--;
          },1000)
          this.form.key = res.key;
        } else {
          this.sendBtn = false;
        }
      }).catch(()=>{
        this.sendBtn = false;
      });
      
    },
    registerSubmit(){
      this.$refs.registerForm.validate(valid=>{
        if(valid){
          regiser(this.form).then(res=>{
            if(res.code==1){
              // this.$emit("loginSuccess");
              this.$message.success(this.$t("message.registerSuccess"),1);
              this.$store.dispatch("setToken", res.token);
              // this.$store.dispatch("getUserInfo", res.user);
              if (isMobile()) {
                this.$router.push({ path: "/mobile/member/mine" });
              } else {
                this.$router.push({ path: "/member" });
              }
            }
          }).catch(err=>{
            console.log("==err=", err);
          })
        }
      })
    },
  },
};
</script>

<style scoped>
.options {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .title {
    line-height: 6;
    text-align: center;
  }
  .content {
    width: 400px;
    margin: 60px auto 0;
    padding: 50px 50px 30px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    vertical-align: middle;
  }
}

@media screen and (max-width: 768px) {
  .title {
    line-height: 6;
    text-align: center;
  }
  .content {
    width: 100%;
    margin: 0 auto 0;
    padding: 50px 50px 30px;
    box-shadow: none;
  }
}
</style>